import { render } from "./AssistenteJuridico.vue?vue&type=template&id=3bf0436a&scoped=true"
import script from "./AssistenteJuridico.vue?vue&type=script&lang=js"
export * from "./AssistenteJuridico.vue?vue&type=script&lang=js"

import "./AssistenteJuridico.vue?vue&type=style&index=0&id=3bf0436a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf0436a"]])

export default __exports__